import { useEffect, useState } from 'react';
import { getMangoPayTransactions } from 'src/api/pmApi';
import { apiErrorHandling } from '../api/apierrorhandling';
import { MangoTransaction } from '../models';
import { generalStore } from 'src/stores/GeneralStore';

export const useMangoTransactions = (
  mangopayId: string | null,
  mangopayWalletId: string | null,
  options: {
    from?: Date;
    to?: Date;
    page?: string;
    pageSize?: string;
    mangopayTransactionStatus?: string;
  },
  refresh?: boolean,
) => {
  const { from, to, page, pageSize, mangopayTransactionStatus } = options;
  const [mangopay, setMangopay] = useState<MangoTransaction[]>([]);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        if (!mangopayId || !mangopayWalletId) return;
        const response = (await getMangoPayTransactions(mangopayId, mangopayWalletId, from, to, page, pageSize, mangopayTransactionStatus))
          .data;
        setMangopay(response);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    if (!mangopayId || !mangopayWalletId || !page || !pageSize) return;
    load();
  }, [mangopayId, page, pageSize, refresh]);
  return mangopay;
};
